"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DELIVERY_ACTIVITY_WINDOW_DAYS = void 0;
/**
 * Delivery-mode activity gate: a repo whose most recent push/commit is older
 * than this many days is excluded from Delivery scanning (both the org-wide
 * bulk-enumeration path and the pre-resolved/team-scan path in
 * `lambdas/repo-discovery`). A value that gates producer/consumer agreement
 * MUST be defined once here and imported by every consumer — never
 * re-declared as a per-Lambda literal.
 */
exports.DELIVERY_ACTIVITY_WINDOW_DAYS = 30;
//# sourceMappingURL=delivery.js.map